export const NOTIFICATION_TYPES = {
  SERVICE_UPDATE: 'service_update',
  ITV_EXPIRATION: 'itv_expiration',
  MAINTENANCE_MILEAGE: 'maintenance_mileage',
  MAINTENANCE_ANNUAL: 'maintenance_annual',
  TIRE_MAINTENANCE: 'tire_maintenance',
  WASH_AFTER_RAIN: 'wash_after_rain',
  WASH_BIWEEKLY: 'wash_biweekly',
  SERVICE_PICKUP: 'service_pickup'
} as const;

export const NOTIFICATION_ACTIONS = {
  VIEW_SERVICE: 'view_service',
  SCHEDULE_ITV: 'schedule_itv',
  SCHEDULE_MAINTENANCE: 'schedule_maintenance',
  SCHEDULE_ANNUAL: 'schedule_annual',
  SCHEDULE_TIRES: 'schedule_tires',
  SCHEDULE_WASH: 'schedule_wash',
  SCHEDULE_PICKUP: 'schedule_pickup'
} as const;

export type NotificationType = typeof NOTIFICATION_TYPES[keyof typeof NOTIFICATION_TYPES];
export type NotificationActionType = typeof NOTIFICATION_ACTIONS[keyof typeof NOTIFICATION_ACTIONS];

export enum NotificationChannel {
  CHATBOT = 'chatbot',
  HEADER = 'header'
} 
